import type { CrudTableColumn } from '@/types/crud-config'

export const dingGroupColumns: CrudTableColumn[] = [
  {
    label: '群名称',
    prop: 'groupName',
    minWidth: 160,
    showOverflowTooltip: true
  },
  {
    label: '钉钉部门ID',
    prop: 'dingDeptId',
    minWidth: 130,
    showOverflowTooltip: true
  },
  {
    label: '钉钉部门名称',
    prop: 'dingDeptName',
    minWidth: 150,
    showOverflowTooltip: true
  },
  {
    label: '路由类型',
    prop: 'routeType',
    minWidth: 100,
    formatter: (row) => {
      switch (row.routeType) {
        case 1:
          return '常规'
        case 2:
          return '兜底'
        default:
          return row.routeType
      }
    }
  },
  {
    label: '路由标识',
    prop: 'routeKey',
    minWidth: 150,
    showOverflowTooltip: true
  },
  { label: '状态', prop: 'enabled', slot: 'enabled', width: 90 },
  {
    label: 'Webhook（脱敏）',
    prop: 'webhookCiphertext',
    minWidth: 190,
    showOverflowTooltip: true
  },
  {
    label: 'Secret（脱敏）',
    prop: 'secretCiphertext',
    minWidth: 160,
    showOverflowTooltip: true
  },
  { label: '备注', prop: 'remark', minWidth: 180, showOverflowTooltip: true },
  {
    label: '最后修改人',
    prop: 'updatedBy',
    minWidth: 110,
    showOverflowTooltip: true
  },
  {
    label: '最后修改时间',
    prop: 'updatedAt',
    minWidth: 170,
    showOverflowTooltip: true
  },
  { label: '操作', slot: 'rowActions', width: 140, fixed: 'right' }
]
